/* eslint-disable @typescript-eslint/ban-ts-comment */
import {taxGuruAxios} from "../axios";
import {taxVatRateUrls} from "../url";
import {Filter} from "@mm-products/java-multima-framework";
import {TaxVatRateResult} from "../models/TaxVatRateResult";
import {TaxVatRateDto} from "../models/TaxVatRateDto";
import {VatRatesFormType} from "../../../modules/vatRates/VatRatesDetailPage";
import {TaxAccountantDto} from "../models/TaxAccountantDto";

export const listTaxVatRates = (filter: Filter, signal?: AbortSignal, toastId?: string): Promise<TaxVatRateResult> => {
    return taxGuruAxios.post(taxVatRateUrls.filter, filter, {
        // @ts-ignore
        toastId,
        signal,
    }).then((data) => data.data);
};
export const getTaxVatRate = (vatRateId: string, toastId?: string, signal?: AbortSignal, noErrorToast?: boolean): Promise<TaxVatRateDto> => {
    return taxGuruAxios
        .get(taxVatRateUrls.get(encodeURIComponent(vatRateId)), {
            // @ts-ignore
            toastId,
            signal,
            noErrorToast,
        })
        .then((data) => data.data);
};

export const createVatRate = (vatRate: VatRatesFormType, toastId?: string, signal?: AbortSignal, noErrorToast?: boolean): Promise<TaxVatRateDto> => {
    return taxGuruAxios
        .post(taxVatRateUrls.create, vatRate, {
            // @ts-ignore
            toastId,
            signal,
            noErrorToast,
        })
        .then((data) => data.data);
};

export const updateVatRate = (vatRateId: string, vatRate: VatRatesFormType, toastId?: string): Promise<TaxVatRateDto> => {
    return taxGuruAxios
        .put(taxVatRateUrls.update(encodeURIComponent(vatRateId)), vatRate, {
            // @ts-ignore
            toastId,
        })
        .then((data) => data.data);
};
export const deleteVatRate = (vatRateId: string, toastId?: string): Promise<TaxAccountantDto> => {
    return taxGuruAxios
        .delete(taxVatRateUrls.delete(encodeURIComponent(vatRateId)), {
            // @ts-ignore
            toastId,
        })
        .then(({ data }) => data);
};
